import moment from 'moment-timezone'

export default {
    methods: {
        generateEventTimeList (events, timezone) {
            const timeList = {}
            const todayUTC = moment.utc()

            events.forEach(event => {
                const startUTC = moment.utc(event.startUTC),
                    endUTC = moment.utc(event.endUTC)
                const startUserZone = startUTC.clone().tz(timezone),
                    endUserZone = endUTC.clone().tz(timezone)
                const isPassedEvent = startUTC.isSameOrBefore(todayUTC, 'hour')

                if (isPassedEvent) {
                    return
                }

                const day = startUserZone.format('dddd, DD MMMM YYYY')
                const startTime = startUserZone.format('HH:mm'),
                    endTime = endUserZone.format('HH:mm')

                if (!timeList[day]) {
                    timeList[day] = []
                }

                const eventName = event.eventType.name
                if (eventName === 'available_custom' || eventName ===
                    'availability') { //appointment
                    if (!timeList[day]['available']) {
                        timeList[day]['available'] = []
                    }

                    timeList[day]['available'].push({
                        'start': startTime,
                        'end': endTime,
                        'eventId': event.id,
                        'typeID': event.type_id,
                        'meeting': event.meeting,
                    })
                } else if (eventName === 'appointment') {
                    if (!timeList[day]['appointment']) {
                        timeList[day]['appointment'] = []
                    }

                    timeList[day]['appointment'].push({
                        'start': startTime,
                        'end': endTime,
                        'eventId': event.id,
                        'typeID': event.type_id,
                        'meeting': event.meeting,
                    })
                }
            })

            return timeList
        },
        async deleteAvailability (selectedEvent) {
            const conf = confirm('Are you sure?')
            if (!conf) {
                return
            }
            const meetingId = selectedEvent.meeting !== undefined ? selectedEvent.meeting.id : null
            await this.$store.dispatch('events/deleteEvent', { eventId: selectedEvent.eventId, meetingId: meetingId })
            if(parseInt(selectedEvent.eventId) === parseInt(this.checkedAvail)) {
                this.checkedAvail = null
            }
        }
    }
}
